"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permissions = void 0;
var Permissions;
(function (Permissions) {
    Permissions["READ"] = "read";
    Permissions["CREATE"] = "create";
    Permissions["EDIT"] = "edit";
    Permissions["DELETE"] = "delete";
    Permissions["SHARE"] = "share";
    Permissions["INVITE"] = "invite";
    Permissions["EXPORT"] = "export";
    Permissions["LINK"] = "link";
    Permissions["INSTALLATION_LINK"] = "installationLink";
    Permissions["CONFIGURE"] = "configure";
    Permissions["DISABLE"] = "disable";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
